<template>
    <div class="client">
        <div class="container-fluid">
            <div class="animated fadeIn">
                <div class="card">
                    <div class="card-body">
                        <b-modal v-model="showLoadingCMD" width="auto" trap-focus :destroy-on-hide="true"
                            aria-role="dialog" aria-modal :can-cancel="false">
                            <template #default="props">
                                <LoadingCMD @close="props.close" :CMD="cmd" :sendingCMDMessage="sendingCMDMessage"
                                    :countDown="countDown" @ActionAfterClientOptions="afterClientOptions"
                                    :route="route">
                                </LoadingCMD>
                            </template>
                        </b-modal>
                        <b-field grouped>
                            <div class="col-lg-6 searchTerminal">
                                <b-input :placeholder="translate('lblSearchByName')" expanded type="search"
                                    icon="magnify" @icon-right-click="searchByName = ''" icon-right="close-circle"
                                    icon-right-clickable id="lblSearchByName" v-model="searchByName" style="width: 98%; float: right;"/>
                            </div>
                            <div class="col-lg-3" style="text-align: right;">
                                <b-select v-if="false" v-model="searchByConnected"
                                    :placeholder="translate('columnStatus')">
                                    <option v-for="option in clientStatus" :value="option.value" :key="option.value">
                                        {{ translate(option.name) }}
                                    </option>
                                </b-select>
                                <b-dropdown aria-role="list" scrollable max-height="300" trap-focus
                                    v-model="searchByConnected">
                                    <template #trigger>
                                        <a class="navbar-item" role="button">
                                            {{ translate("columnStatus") }}: {{ translate(searchByConnected.name) }}
                                            <b-icon icon="menu-down"></b-icon>
                                        </a>
                                    </template>
                                    <b-dropdown-item v-for="option in clientStatus" :value="option" :key="option.name">
                                        <span>{{ translate(option.name) }}</span>
                                    </b-dropdown-item>
                                </b-dropdown>                                
                            </div>
                            <div class="col-lg-3" style="text-align: left;">
                                <b-select v-if="false" v-model="searchByServer"
                                    :placeholder="translate('columnServer')">
                                    <option v-for="option in clientStatus" :value="option.value" :key="option.value">
                                        {{ translate(option.name) }}
                                    </option>
                                </b-select>
                                <b-dropdown aria-role="list" scrollable max-height="300" trap-focus
                                    v-model="searchByServer">
                                    <template #trigger>
                                        <a class="navbar-item" role="button">
                                            <span v-if="searchByServer.name == '' || searchByServer.name == 'All'">
                                                {{ translate("lblSearchByServer") }}
                                            </span>
                                            <span v-else>
                                                {{ translate("columnServer") }}: {{ searchByServer.name }}
                                            </span>
                                            <b-icon icon="menu-down"></b-icon>
                                        </a>
                                    </template>
                                    <b-dropdown-item v-for="option in listClients" :value="option" :key="option.name">
                                        <span>{{ option.name }}</span>
                                    </b-dropdown-item>
                                </b-dropdown>
                            </div>

                        </b-field>
                        <div style="overflow-y: auto; height: 100% !important">
                            <div class="terminal-tab" style="
                                                  overflow-y: auto;
                                                  overflow-x: hidden;
                                                  padding-left: 14px;
                                                  font-size: 5px !important;
                                                ">
                                &nbsp;
                                <span>
                                    {{ translate("activeClients") }} [{{ activeClient }}]
                                    | {{ translate("inactiveClients") }} [{{ inactiveClient }}]
                                    | {{ translate("blockedClients") }} [{{ blockedClient }}]
                                    | {{ translate("deletedClients") }} [{{ deletedClient }}]
                                    | {{ translate("noCommunicationClients") }} [{{ noCommunicationClient }}]
                                    | {{ translate("InFilter") }} [{{ inFilter }}]
                                </span>
                                <br />
                                <br />
                                <button class="stat-terminal" v-for="(client, pos) in clients" :key="client.IdClient"
                                    :title="client.Name + '\n' + (client.ClientType == 2 ? 'System Server' : 'Sirius Server') + '\n' + client.ClientVersion + '\n' + client.DateUpdate + ' (UTC)'" data-toggle="tooltip" data-placement="top"
                                    style="min-width: 150px; min-height: 150px; margin-bottom: 10px; "
                                    :disabled="!enableShowInfoClient" @click.prevent="processShowClient(client)"
                                    v-show="verifyNameClient(client)">                                    
                                    <div class="stat-icon">
                                        <div class="row" style="">
                                            <div
                                                style="padding-left: 45px !important; padding-bottom: 10px !important;">
                                                <p class="icons-lg icons-server-config" :style="getStyle(client)" />
                                            </div>
                                            &nbsp;&nbsp;&nbsp;&nbsp;
                                            <div style="padding-bottom: 40px !important; width: 20px !important; color: #E9E9E9 !important;">
                                                <b-button size="is-small" style="border-color: white; position: static" v-if="userLogged != null && !userLogged.Watcher" 
                                                    @mouseenter="processDisableShowClient(pos)"
                                                    @mouseleave="processEnableShowClient()" @click.prevent="
                            showClientOptionsModal(client)
                            " :title="translate('messageBtnShowClientOptions')
                            " icon-left=".icons icons-dots-three-vertical" icon-pack="icons" />
                                            </div>
                                            &nbsp;
                                        </div>
                                        <span class="stat-title-terminal" :style="getStyleTerminal(pos)">
                                            {{ client.Name.slice(0, 24) + (client.Name.length > 24 ? "..." : "") }}
                                            <br />
                                            {{ client.ClientType == 2 ? "System Server" : client.ClientType == 3 ? "Sirius Server (DINGO)" : "Sirius Server (FBM)" }}
                                            <br />
                                            {{ client.ClientVersion }}
                                            <br />
                                        </span>
                                        <span class="stat-title-terminal" :style="getStyleTerminal(pos)">
                                            <i class="icons-lg icons-calendar" style="color: #777777"></i>&nbsp;{{ client.DateUpdate }} (UTC)
                                        </span>
                                    </div>
                                    <br />
                                </button>
                            </div>
                            <div :class="'col-lg-' + (12 - 2 * ((clients.length + 1) % 4))" />
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <b-modal v-model="showClientOptions" width="600px" trap-focus :destroy-on-hide="true" :can-cancel="false"
            aria-role="dialog" aria-modal>
            <template>
                <div class="modal-card" style="width: 100%; height: 450px">
                    <header class="modal-card-head">
                        <p class="modal-card-title">
                            {{ translate("messageBtnShowClientOptions") }} -
                            {{ selectedClient.Name }}
                        </p>
                        <button type="button" class="delete" @click="showClientOptions = false" />
                    </header>
                    <section class="modal-card-body">
                        <b-modal v-model="showLoadingClientOptionsCMD" width="auto" trap-focus :destroy-on-hide="true"
                            aria-role="dialog" aria-modal :can-cancel="false">
                            <template #default="props">
                                <LoadingCMD @close="props.close" :CMD="cmd" :sendingCMDMessage="sendingCMDMessage"
                                    :countDown="countDown" @ActionAfterClientOptions="afterClientOptions"
                                    :JsonObject="obj">
                                </LoadingCMD>
                            </template>
                        </b-modal>
                        <b-dropdown v-model="selectClientOption" aria-role="list" expanded>
                            <template v-if="true" #trigger>
                                <b-button v-if="selectClientOption == clientOptions.block" expanded
                                    :label="translate('btnBlockClient')" icon-left=".icons-white icons-server-config"
                                    icon-pack="icons" />
                                <b-button v-if="selectClientOption == clientOptions.unblock" expanded
                                    :label="translate('btnUnblockClient')" icon-left=".icons-white icons-server-config"
                                    icon-pack="icons" />
                                <b-button v-if="selectClientOption == clientOptions.delete" expanded
                                    :label="translate('btnDeleteClient')" icon-left=".icons-white icons-trash"
                                    icon-pack="icons" />
                                <b-button v-if="selectClientOption == clientOptions.recover" expanded
                                    :label="translate('btnRecoverClient')"
                                    icon-left=".icons-white icons-trash-arrow-up-solid" icon-pack="icons" />
                            </template>

                            <b-dropdown-item :value="clientOptions.block" aria-role="listitem"
                                v-if="!selectedClient.Blocked && !selectedClient.Deleted">
                                <span><i class="icons-server-config" />
                                    {{ translate("btnBlockClient") }}</span>
                            </b-dropdown-item>

                            <b-dropdown-item :value="clientOptions.unblock" aria-role="listitem"
                                v-if="selectedClient.Blocked && !selectedClient.Deleted">
                                <span><i class="icons icons-server-config" />
                                    {{ translate("btnUnblockClient") }}</span>
                            </b-dropdown-item>

                            <b-dropdown-item :value="clientOptions.recover" aria-role="listitem"
                                v-if="selectedClient.Deleted">
                                <span><i class="icons icons-trash-arrow-up-solid" />
                                    {{ translate("btnRecoverClient") }}</span>
                            </b-dropdown-item>

                            <b-dropdown-item :value="clientOptions.delete" aria-role="listitem"
                                v-if="!selectedClient.Deleted && !selectedClient.Connected && selectedClient.Blocked">
                                <span><i class="icons icons-trash" />
                                    {{ translate("btnDeleteClient") }}</span>
                            </b-dropdown-item>
                        </b-dropdown>
                    </section>
                    <footer class="modal-card-foot">
                        <b-button @click="showClientOptions = false" :label="translate('btnCancel')"
                            icon-left=".icons-white icons-times" icon-pack="icons" />
                        <b-button @click="processSendOption()" :label="translate('btnOk')" type="is-primary"
                            :icon-left="'.icons-white icons-check'" icon-pack="icons" />
                    </footer>
                </div>
            </template>
        </b-modal>

        <b-modal v-model="showProcessClient" :key="showProcessClient" width="1200px" trap-focus :destroy-on-hide="true"
            :can-cancel="false" aria-role="dialog" aria-modal>
            <template>
                <div class="modal-card" style="width: 100%; height: 650px">
                    <header class="modal-card-head">
                        <p class="modal-card-title">{{ this.selectedClient.Name }}</p>
                        <button type="button" class="delete" @click="showProcessClient = false" />
                    </header>
                    <section class="modal-card-body">

                        <b-modal v-model="showLoadingProcessClientCMD" width="auto" trap-focus :destroy-on-hide="true"
                            aria-role="dialog" aria-modal :can-cancel="false">
                            <template #default="props">
                                <LoadingCMD @close="props.close" :CMD="cmd" :sendingCMDMessage="sendingCMDMessage"
                                    :countDown="countDown" @ActionAfterClientOptions="afterClientOptions"
                                    :JsonObject="obj">
                                </LoadingCMD>
                            </template>
                        </b-modal>
                        <b-field v-if="isElectronVar">
                            <button class="btn btn-outline-secondary" disabled>
                                <i class="icons-lg0 icons-usb" />
                            </button>
                            &nbsp;
                            <b-select :placeholder="translate('lblSelectDevice')" v-model="penDriveSelected" expanded>
                                <option v-for="penDrive in penDriveList" v-bind:value="penDrive" :key="penDrive.Name">
                                    {{ penDrive.Name }}
                                </option>
                            </b-select>
                            &nbsp;
                            <button class="btn btn-outline-secondary" @click.prevent="refreshPenDrive()">
                                <i class="icons-lg0 icons-sync" />
                            </button>
                            &nbsp;
                        </b-field>
                        <p></p>
                        <b-field grouped>
                            <div class="col-lg-3" style="padding: 0;">
                                <b-select v-if="false" v-model="searchByStatus"
                                    :placeholder="translate('columnStatus')">
                                    <option v-for="option in clientStatus" :value="option.value" :key="option.value">
                                        {{ option.name }}
                                    </option>
                                </b-select>
                                <b-dropdown aria-role="list" scrollable max-height="200" trap-focus
                                    v-model="searchByStatus">
                                    <template #trigger>
                                        <a class="navbar-item" role="button">
                                            {{ translate("columnStatus") }}: {{ searchByStatus.name }}
                                            <b-icon icon="menu-down"></b-icon>
                                        </a>
                                    </template>
                                    <b-dropdown-item v-for="option in megapotConnStatus" :value="option" :key="option.name">
                                        <span>{{ option.name }}</span>
                                    </b-dropdown-item>
                                </b-dropdown>
                            </div>
                            <div class="col-lg-6">
                                <div style="display: inline-flex; width: 100%">
                                    <span :label="translate('lblSelectDate')"
                                        style="padding-top: 8px; padding-right: 25px;">
                                        {{ translate('lblSelectDate') }}:
                                    </span>
                                    <b-datepicker v-model="dates" range required :locale="locale" style="width: 50%;"
                                        :placeholder="translate('lblClickToSelect')" icon="calendar-today" trap-focus
                                        :icon-right="dates ? 'close-circle' : ''" icon-right-clickable
                                        @icon-right-click="clearDate"  >
                                    </b-datepicker>

                                </div>

                            </div>
                            <div class="col-lg-3" style="padding-left: 110px;">
                                <b-button label="Download History" type="is-warning"
                                    :disabled="(isElectronVar && penDriveSelected == null) || listConnectionHistory.length == 0"
                                    icon-right=".icons-white icons-download" icon-pack="icons"
                                    @click.prevent="processDownloadHistory(listConnectionHistory)"></b-button>
                            </div>
                        </b-field>
                        <p></p>
                        <b-table class="has-background-color-dark" :data="listConnectionHistory"
                            aria-next-label="Next page" aria-previous-label="Previous page" aria-page-label="Page"
                            aria-current-label="Current page" striped bordered>
                            <template #empty>
                                <div class="has-text-centered">
                                    <h1>
                                        <span class="tag is-danger">{{
                            translate("lblNoDataFound")
                        }}</span>
                                    </h1>
                                </div>
                            </template>
                            <b-table-column field="field" :label="translate('columnStatus')" v-slot="props"
                                header-class="is-sticky-column-one" width="200">
                                <template v-if="megapotConnStatus[0].value == props.row.Type">
                                    <span class="tag is-success">
                                        Connected
                                    </span>
                                </template>
                                <template v-if="megapotConnStatus[1].value == props.row.Type">
                                    <span class="tag is-warning">
                                        No Communication
                                    </span>
                                </template>
                                <template v-if="megapotConnStatus[2].value == props.row.Type">
                                    <span class="tag is-danger">
                                        Disconnected
                                    </span>
                                </template>
                            </b-table-column>
                            <b-table-column field="value" :label="translate('columnDate')" v-slot="props"
                                header-class="is-sticky-column-one" width="200">
                                {{ props.row.Date }}
                            </b-table-column>
                            <b-table-column field="value" :label="translate('columnLastUpdated')" v-slot="props"
                                header-class="is-sticky-column-one" width="200">
                                {{ props.row.LastUpdate }}
                            </b-table-column>
                        </b-table>
                    </section>
                </div>
            </template>
        </b-modal>
    </div>
</template>
<script>
import { mapState } from "vuex";
import { clientStatus, clientOptions, listClients, megapotConnStatus } from "@/mixins/enums.js";
import { clientCommands } from "@/js/ClientCommands.js";
import en from "@/mixins/languages/en.js";
import es from "@/mixins/languages/es.js";
import nor from "@/mixins/languages/nor.js";
import swe from "@/mixins/languages/swe.js";
import LoadingCMD from "@/components/processCMD/LoadingCMD.vue";
import validateField from "@/js/validateField";
export default {
    name: "Client",
    mixins: [en, es, nor, swe],
    components: { LoadingCMD },
    computed: mapState([
        "lang",
        "dataModule",
        "currentTab",
        "completeLogin",
        "isElectronVar",
        "userLogged",
        "locale",
    ]),

    data: function () {
        return {
            name: "",
            showLoadingCMD: false,
            cmd: "",
            countDown: 60,
            route: "",
            intervalGetDatas: null,
            showClientModal: false,
            searchByName: "",
            searchByConnected: { value: 0, name: "" },
            searchByServer: { value: 0, name: "" },
            searchByStatus: { value: 0, name: "" },
            clientStatus: clientStatus,
            listClients: listClients,
            clients: [],
            activeClient: 0,
            inactiveClient: 0,
            blockedClient: 0,
            deletedClient: 0,
            noCommunicationClient: 0,
            inFilter: 0,
            showLoadingClientOptionsCMD: false,
            clientOptions: clientOptions,
            showClientOptions: false,
            selectedClient: {},
            selectClientOption: 0,
            showProcessClient: false,
            megapotConnStatus: megapotConnStatus,
            listConnectionHistory: [],
            showLoadingProcessClientCMD: false,
            penDriveList: [],
            penDriveSelected: null,
            enableShowInfoClient: true,
            posClient: -1,
            dates: [],
            selected: new Date(),
            showWeekNumber: false,            
        }
    },
    methods: {
        translate(prop) {
            return this[this.lang][prop];
        },
        getStyle(client) {
            if (client.Deleted) {
                return "color: #FF8888; font-size: xxx-large;";
            } else if (client.Blocked) {
                return "color: #EE3333; font-size: xxx-large;";
            } else if(client.IsNoCommunication){
                return"color: #FFE08A; font-size: xxx-large;";
            } else if (client.Connected) {
                return "color: #339933; font-size: xxx-large;";
            } else {
                return "color: #CCCCCC; font-size: xxx-large;";
            }
        },
        getDatas() {
            try {
                this.intervalGetDatas = setInterval(() => {
                    if (
                        this.currentTab != "Client" ||
                        !this.completeLogin
                    ) {
                        console.log("/closed getDatas Client()");
                        clearInterval(this.intervalGetDatas);
                    }
                    this.clients = this.dataModule.Clients
                    let activeClient = 0;
                    let inactiveClient = 0;
                    let blockedClient = 0;
                    let deletedClient = 0;
                    let noCommunicationClient = 0;
                    let inFilter = 0;
                    this.clients.forEach((client) => {
                        if (client.Connected && !client.IsNoCommunication) {
                            activeClient = activeClient + 1;
                        } else if (client.Deleted) {
                            deletedClient = deletedClient + 1;
                        } else if (client.Blocked) {
                            blockedClient = blockedClient + 1;
                        } else if(client.Connected && client.IsNoCommunication){
                            noCommunicationClient = noCommunicationClient + 1;
                        } 
                        else {
                            inactiveClient = inactiveClient + 1;
                        }
                        if (this.verifyNameClient(client)) {
                            inFilter = inFilter + 1;
                            console.log("/mountedDataClient()");
                        }
                    });
                    this.activeClient = activeClient;
                    this.inactiveClient = inactiveClient;
                    this.blockedClient = blockedClient;
                    this.deletedClient = deletedClient;
                    this.noCommunicationClient = noCommunicationClient
                    this.inFilter = inFilter;
                }, 1000);
            } catch (e) {
                console.log("Error in GetDatas() Client " + e);
            }
        },
        verifyNameClient(client) {
            let ret = false;
            if ((client.Name.toLowerCase()).includes(this.searchByName.toLowerCase())) {
                if (this.searchByServer.value == 0 || this.searchByServer.value == client.ClientType
                    || (this.searchByServer.value == 99 && (client.ClientType == 1 || client.ClientType == 3))
                ) {
                    if (this.searchByConnected.value == 0 && client.Connected) {
                        ret = true;
                    } else if (this.searchByConnected.value == 1 && !client.Connected && !client.Blocked && !client.Deleted) {
                        ret = true;
                    } else if (this.searchByConnected.value == 2 && client.Blocked && !client.Deleted) {
                        ret = true;
                    } else if (this.searchByConnected.value == 3 && client.Deleted) {
                        ret = true;
                    } else if (this.searchByConnected.value == 4) {
                        ret = true;
                    } else if (this.searchByConnected.value == 5 && client.IsNoCommunication) {
                        ret = true;
                    }
                }
            }
            return ret;
        },

        processShowClient(client) {
            this.selectedClient = client;
            this.listConnectionHistory = this.selectedClient.ConnectionHistory;
            this.penDriveSelected = null;
            this.searchByStatus = megapotConnStatus[3];
            this.filterList()
            if (this.isElectronVar) {
                this.refreshPenDrive()
            } else {
                this.showProcessClient = true;
            }
            this.dates = []
        },

        refreshPenDrive() {
            this.penDriveSelected = null
            this.cmd = clientCommands.GetPenDriveList.name;
            this.obj = {};
            this.countDown = clientCommands.GetPenDriveList.time;
            this.sendingCMDMessage =
                this.translate("waiting") +
                " " +
                this.translate("messageRequestPenDriveList");
            this.route = "/components/Client";
            if (this.showProcessClient) {
                this.showLoadingProcessClientCMD = true;
            } else {
                this.showLoadingCMD = true
            }
        },

        closeProcessClient() {
            this.showProcessClient = false;
            this.selectedClient = null;
            this.dates = []
        },

        showClientOptionsModal(client) {
            this.showClientOptions = true;
            this.selectedClient = client;

            if (!client.Blocked && !client.Deleted) {
                this.selectClientOption = clientOptions.block;
            } else if (client.Blocked && !client.Deleted) {
                this.selectClientOption = clientOptions.unblock;
            } else if (client.Deleted) {
                this.selectClientOption = clientOptions.recover;
            } else {
                this.selectClientOption = clientOptions.delete;
            }

        },
        processSendOption() {
            if (this.selectClientOption == clientOptions.block) { // Block Client
                this.$buefy.dialog.confirm({
                    title: this.translate("dialog_Title"),
                    message:
                        this.translate("msgBlockClientConfirmation") +
                        " <br/> " +
                        this.selectedClient.Name,
                    confirmText: this.translate("btnYes"),
                    cancelText: this.translate("btnCancel"),
                    type: "is-primary",
                    hasIcon: true,
                    onConfirm: () => this.sendOption(this.selectClientOption),
                });
            } else if (this.selectClientOption == clientOptions.unblock) { // Unblock Client
                this.$buefy.dialog.confirm({
                    title: this.translate("dialog_Title"),
                    message:
                        this.translate("msgUnblockClientConfirmation") +
                        " <br/> " +
                        this.selectedClient.Name,
                    confirmText: this.translate("btnYes"),
                    cancelText: this.translate("btnCancel"),
                    type: "is-primary",
                    hasIcon: true,
                    onConfirm: () => this.sendOption(this.selectClientOption),
                });
            }
            else if (this.selectClientOption == clientOptions.delete) { // Delete Client
                this.$buefy.dialog.confirm({
                    title: this.translate("dialog_Title"),
                    message:
                        this.translate("msgDeleteClientConfirmation") +
                        " <br/> " +
                        this.selectedClient.Name,
                    confirmText: this.translate("btnYes"),
                    cancelText: this.translate("btnCancel"),
                    type: "is-primary",
                    hasIcon: true,
                    onConfirm: () => this.sendOption(this.selectClientOption),
                });
            }
            else if (this.selectClientOption == clientOptions.recover) { // Recover Client
                this.$buefy.dialog.confirm({
                    title: this.translate("dialog_Title"),
                    message:
                        this.translate("msgRecoverClientConfirmation") +
                        " <br/> " +
                        this.selectedClient.Name,
                    confirmText: this.translate("btnYes"),
                    cancelText: this.translate("btnCancel"),
                    type: "is-primary",
                    hasIcon: true,
                    onConfirm: () => this.sendOption(this.selectClientOption),
                });
            }
        },
        sendOption(selectedOption) {
            try {
                this.cmd = clientCommands.ClientOptions.name;
                this.countDown = clientCommands.ClientOptions.time;
                this.sendingCMDMessage = this.translate("lblLoading");
                this.obj = {
                    Client: this.selectedClient,
                    Option: selectedOption,
                };
                this.showLoadingClientOptionsCMD = true;
            } catch (e) {
                console.log("Error in sendGroupMachinesOption()" + e);
            }
        },
        afterClientOptions(data) {
            try {

                if (!data.ok) {
                    //
                } else {
                    switch (data.cmd) {
                        case clientCommands.GetPenDriveList.name:
                            this.penDriveList = data.object.PenDriveInfoList;
                            this.showProcessClient = true;
                            break;
                        case clientCommands.DownloadConnectionHistory.name:
                            this.showProcessClient = false;
                            break;
                        default:
                            this.showClientOptions = false;
                            break;
                    }
                }
            } catch (e) {
                console.log("Error in afterClientOptions()" + e);
            }

        },
        processDownloadHistory(list) {
            try {
                this.downloadHistory(list)
            } catch (e) {
                console.log("Error in processDownloadHistory()" + e);
            }
        },
        downloadHistory(list) {
            try {
                this.cmd = clientCommands.DownloadConnectionHistory.name;
                this.countDown = clientCommands.DownloadConnectionHistory.time;
                this.sendingCMDMessage = this.translate("lblLoading");
                this.obj = {
                    ListHistory: list,
                    PenDriveInfo: this.penDriveSelected
                };
                this.showLoadingProcessClientCMD = true;
            } catch (e) {
                console.log("Error in processDownloadHistory()" + e);
            }
        },
        processDisableShowClient(pos) {
            this.posClient = pos
            this.enableShowInfoClient = false
        },
        processEnableShowClient() {
            this.posClient = -1
            this.enableShowInfoClient = true
        },
        getStyleTerminal(pos) {
            if (pos == this.posClient) {
                return "font-size: 9px !important; color: gray;"
            } else {
                return "font-size: 9px !important;"
            }
        },
        clearDate() {
            this.dates = []
        },
        filterList() {
            let list = []
            if (this.searchByStatus.value == megapotConnStatus[3].value) {
                list = this.selectedClient.ConnectionHistory
            } else {
                list = this.selectedClient.ConnectionHistory.filter(item => item.Type == this.searchByStatus.value)
            }            

            if (this.dates != [] && this.dates.length > 1) {

                const date01 = validateField.sampleFormat(this.dates[0]);
                const date02 = validateField.sampleFormat(this.dates[1]);

                list = list.filter(item => {
                    return item.Date.split(" ")[0] >= date01 && item.Date.split(" ")[0] <= date02;
                });

            }

            this.listConnectionHistory = list
        }

    },
    created() {
        this.clients = this.dataModule.Clients
        if (this.currentTab == "Client")
            this.getDatas();
    },
    mounted() {
        this.searchByConnected = clientStatus[0]
        this.searchByServer = listClients[0]
    },
    beforeDestroy() {
        console.log("/closed getDatas()");
        clearInterval(this.intervalGetDatas);
    },
    watch: {
        searchByStatus() {
            this.filterList()
        },
        dates() {
            this.filterList()
        }

    }
}
</script>
<style scoped src="@/css/styleModules.css"></style>
